module.exports = __webpack_public_path__ + "static/media/Case_hospital.5f98825a.png";